export default __webpack_public_path__ + "static/media/design-title.314f32c3.svg";